<template>
  <div class="student-class-list">
    <threeArea v-for="(item, index) in studentList" :key="index" class="student-info" :class="{ active: !item.state }" @click.native="goView(item.id)">
      <div slot="left">
        <div class="user-img">
          <img src="@assets/images/1.jpg" alt="">
        </div>
      </div>
      <div slot="content">
        <div class="info-title">
          <div class="name"> {{ item.name }} </div>
          <div class="sex"> {{ item.sex }} </div>
        </div>
        <div class="year">年龄：{{ item.year }} </div>
      </div>
      <div slot="right">
        <div class="state" :style="{ color: !item.state ? '#2980f7' : 'black' }"><Icon type="ios-time" color="#f48b16e8"  size="22"/>  {{ getState(item.state) }} </div>
        <div v-if="!item.state" class="class-time"> 时间：{{ item.classStartTime }} </div>
      </div>
    </threeArea>
  </div>
</template>

<script>
  import ThreeArea from '@components/moduleBox/threeArea'
  
  import { getUserStudent, getUserStudentLesson } from '@api/user'
  import { getWeek, sort, addZoo } from '@common'

  export default {
    name: 'SutdentClassList',
    components: {
      ThreeArea
    },
    data() {
      return {
        studentInfoList: [],
        studentList: []
      }
    },
    mounted() {
      this.getUserStudentList();
      },
    methods: {
      getUserStudentList() {  //获取学生
        getUserStudent(this.$route.params.uid).then(res => {
          let resList = res.data;
          let studentIdList = [];
          for (let item of resList.student) {
            this.studentInfoList.push({
              name: item.name,
              id: item.Id,
              sex: item.sex,
              year: ((new Date().getFullYear() - new Date(Number(item.birthday+'000')).getFullYear())) <= 0 ? 0 : ((new Date().getFullYear() - new Date(Number(item.birthday+'000')).getFullYear()))
            })
            studentIdList.push(item.Id)
          }
          this.getStudentList(studentIdList);
        })
      },
      getStudentList(list) { //获取学生课程
        getUserStudentLesson({student_id: list}).then(res => {
          let resList = res.data.studentLesson;
          for (let item of resList) {
            for (let item_mix of item) {
              if (getWeek(Number(item_mix.start_time+'000')) === getWeek()) {
                let timeD = new Date(Number(item_mix.start_time+'000'));
                this.studentList.push({
                  name: item_mix.student_name,
                  lessonId: item_mix.lesson_id,
                  time: Number(item_mix.start_time+'000'),
                  state: 0,
                  classStartTime: timeD.getHours() +':'+ addZoo(timeD.getMinutes()) 
                });
              }else {
                let state;
                let startTime = getWeek(Number(item_mix.start_time+'000'));
                let toTime = getWeek();
                if (startTime < toTime) {
                  state = (startTime + 7) - toTime;
                }else {
                  state = startTime - toTime;
                }
                this.studentList.push({
                  name: item_mix.student_name,
                  lessonId: item_mix.lesson_id,
                  time: Number(item_mix.start_time+'000'),
                  state
                });
              }
            }
          }
          sort(this.studentList,'time');
          sort(this.studentList,'state');
          this.studentList.forEach((item, index) => {
            this.studentInfoList.forEach((item_mix ,index_mix)=> {
              if (item.name === item_mix.name) {
                this.studentList[index].year = this.studentInfoList[index_mix].year; //添加年龄
                this.studentList[index].sex = this.studentInfoList[index_mix].sex; //添加性别
                this.studentList[index].id = this.studentInfoList[index_mix].id; //添加id
              }
            })
          });
        })
      },
      /**
       * 获取开课天数
       */
      getState(state) { 
        if (!state) {
          return '今日有课'
        }else {
          return state + '天后有课'
        }
      },
      /**
       * 页面跳转
       */
      goView(id) {
        if (id) {
          this.$router.push('/user/student/a/lensson/'+ id);
        }
      }
    },
  }
</script>

<style scoped>
  .student-class-list {
    position: relative;
    background-color: white;
    width: 100vw;
    height: 100vh;
    padding: 0.3rem;
    padding-top: 0.5rem;
    overflow-y: scroll;
  }
    .student-info {
      width: 100%;
      height: 1.8rem;
      margin-bottom: 0.3rem;
      padding: 0.2rem;
      justify-content: center;
      align-items: center;
      background-color: rgb(235, 243, 243);
      box-shadow: 0.1rem 0.1rem 0.08rem rgb(226, 226, 226);
      border-radius: 0.2rem;
    }
    .active {
      background-color: rgb(240, 200, 103);
    }
      .user-img {
        width: 1.2rem;
        height: 1.2rem;
        border: 0.1rem solid #f48b16e8;
        border-radius: 0.2rem;
        margin-right: 0.2rem;
        overflow: hidden;
      }
        .user-img img {
          width: 100%;
          height: 100%;
        }
        .info-title {
          display: flex;
        }
        .state, .class-time {
          text-align: center;
        }
        .name {
          font-size: 0.3rem;
          font-weight: 600;
          margin-right: 0.2rem;
        }
        .sex {
          font-size: 0.25rem;
        }
</style>
